module.exports = __webpack_public_path__ + "static/media/other.65f8d21b.mp3";